import axios from 'axios'
import hash from 'object-hash'

import {
  CompassAPIMultiSeriesChartData,
  getMultipleLineChartProps,
  magnitudePointFormatter,
} from '../utils/compass'
import { formatSeriesNames } from '../utils/string'
import type { BaseContext } from './'

const VESSELS_PATH = '/api/charts/vessels'

export namespace Vessels {
  export namespace Exports {
    const CONTEXT_ID = 'equity:vessels:exports'

    export const __typelist: {
      config: ChartConfig
      data: ChartData
      context: ContextType
    } = {} as any

    export type ContextType = BaseContext<
      typeof CONTEXT_ID,
      ChartConfig,
      ChartData
    >

    export interface ChartConfig {
      title?: string
      ports: string[]
      context: typeof CONTEXT_ID
    }

    export type ChartData = CompassAPIMultiSeriesChartData

    const getChartData = async (config: ChartConfig) =>
      axios({
        url: VESSELS_PATH + '/exports',
        method: 'POST',
        data: { ports: config.ports },
      }).then((response) => response.data)

    const getChartProps = (
      config: ChartConfig,
      data: CompassAPIMultiSeriesChartData
    ) =>
      getMultipleLineChartProps(
        Context,
        {
          chartTitle: data.data.length === 0 ? 'No data' : config.title,
          tooltip: {
            pointFormatter: magnitudePointFormatter(),
            xDateFormat: '%B %Y',
          },
          xAxis: { labels: { format: '{value:%m/%Y}' } },
        },
        { type: Array(data.data.length).fill('spline') }
      )(config, formatSeriesNames(data))

    export const Context: ContextType = {
      id: CONTEXT_ID,
      getChartId: (config) =>
        `${config.context}:${hash(config.ports, { unorderedArrays: true })}`,
      getChartData,
      getChartProps,
    }
  }
}
